import { getToken } from "../infrastructure/Auth0Authenticator";
import { action } from "mobx";
import UserContext from "../infrastructure/UserContext";
import ServiceClient from "../infrastructure/client/ServiceClient";
import { ServiceType } from "../infrastructure/enum/ThemeSettings";
import Utils from "../infrastructure/Utils";
import {
  Client as ContractingServiceClient,
} from "../services/ContractingService";
import { googleTagManager } from '../infrastructure/tracking';

class ContractingStore {
  getApiVersion = () => {
    return "1";
  };
  getApiKey = async (): Promise<string> => {
    var token = await getToken();
    return token ? `Bearer ${token}` : "";
  };
  getClient = (): ContractingServiceClient => {
    return ServiceClient.getClient(ServiceType.Contracting);
  };

  @action getSearchAgentList = async (
    searchKey: string,  
  ) => {
    
    googleTagManager.trackAction("agent_search_conducted", {
      feature: "Agents",
      user_id: UserContext.userId,
      search_text:searchKey,
    });

    var result = await this.getClient().getAllAgentDetailsWithActiveLicense(
      this.getApiVersion(),
      searchKey,
      UserContext.userId
    );
    return result;
  };

}
export default new ContractingStore();
